import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "../styles/Navbar.css";

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    // Fungsi untuk menentukan apakah halaman saat ini adalah halaman artikel publik
    const isArticlePage = () => {
        const articlePaths = [
            '/iot-manfaat',
            '/data-science-bisnis',
            '/keamanan-iot',
            '/tips-depot-teknologi',
            '/sebaran-depot'
        ];
        return articlePaths.includes(location.pathname);
    };

    // Efek untuk mengubah warna navbar saat di-scroll
    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 50) { // Jika scroll lebih dari 50px
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []); // ✅ Dependency array kosong, agar efek scroll berlaku universal

    // Fungsi untuk scroll ke bagian di landing page
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setMenuOpen(false); // Tutup menu setelah klik
        }
    };

    // Menentukan kelas CSS navbar
    const navbarClass = `navbar ${scrolled ? "scrolled" : ""} ${isArticlePage() ? "article-page-navbar" : ""}`;

    return (
        <nav className={navbarClass}>
            <div className="navbar-logo">
                <Link to="/">Depot Air Cerdas</Link>
            </div>

            <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <FaTimes /> : <FaBars />}
            </div>

            <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
                {/* Link untuk Landing Page / Beranda */}
                {location.pathname === '/' || location.pathname.startsWith('/#') ? (
                    <>
                        <li><a href="#home" onClick={() => scrollToSection('home')}>Beranda</a></li>
                        <li><a href="#features" onClick={() => scrollToSection('features')}>Fitur</a></li>
                        <li><a href="#workflow" onClick={() => scrollToSection('workflow')}>Cara Kerja</a></li>
                    </>
                ) : (
                    <li><Link to="/">Beranda</Link></li>
                )}
                
                {/* Link ke Halaman Artikel Publik (Blog) */}
                <li><Link to="/iot-manfaat" onClick={() => setMenuOpen(false)}>Manfaat IoT</Link></li>
                <li><Link to="/data-science-bisnis" onClick={() => setMenuOpen(false)}>Data Science</Link></li>
                <li><Link to="/keamanan-iot" onClick={() => setMenuOpen(false)}>Keamanan IoT</Link></li>
                <li><Link to="/tips-depot-teknologi" onClick={() => setMenuOpen(false)}>Tips Depot</Link></li>
                <li><Link to="/sebaran-depot" onClick={() => setMenuOpen(false)}>Peta Sebaran</Link></li>

                {/* Link Daftar dan Login */}
                <li><Link to="/register" className="nav-button" onClick={() => setMenuOpen(false)}>Daftar</Link></li>
                <li><Link to="/login" className="nav-button" onClick={() => setMenuOpen(false)}>Login</Link></li>
            </ul>
        </nav>
    );
};

export default Navbar;